module.exports = __webpack_public_path__ + "static/historias_cuenca_open_source-70ada0b232b1f5e786a87ae26cd6515a.mp4";